import React from "react"
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
// import FacebookIcon from '@mui/icons-material/Facebook'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'

import useStoreSnackbar from "../../stores/storeSnackbar"

import {useMediaQuery} from 'react-responsive'

export default function PageContact(props) {

    // const snackbarData = useStoreSnackbar((state) => state.snackbarData)
    const setSnackbarData = useStoreSnackbar((state) => state.setSnackbarData)

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    function handleCopy(text){
        navigator.clipboard.writeText(text)
        // console.log("Texto copiado al portapapeles:", text)

        setSnackbarData({
            // ...snackbarData,
            open: true,
            message: `Texto copiado al portapapeles: ${text}`,
            severity: "success"
        })
    }

    return (<>
        <Stack 
            direction="column"
            alignItems="center"
            spacing={3}
            sx={{ 
                pb: 15,
                marginX: isTabletOrMobile ? 0.5 : 10
            }}
        >
            <Typography variant="h3" sx={{ mt: 2, mb: 10 }}>
                Información de contacto
            </Typography>
            <Card sx={{ minWidth: 275 }}>
                <CardContent>     
                    <Stack
                        direction="column"
                        alignItems="flex-start"
                    >
                        <Tooltip title="Copiar">
                            <IconButton disableRipple={true} onClick={() => {handleCopy("+56984281885")}}>
                                <Typography variant="h5" color="text.secondary" gutterBottom>
                                    Telefono: +569 84281885
                                </Typography>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Copiar">
                            <IconButton disableRipple={true} onClick={() => {handleCopy("ignacio.rivano@outlook.cl")}}>
                                <Typography variant="h5" color="text.secondary" gutterBottom>
                                    Correo: ignacio.rivano@outlook.cl
                                </Typography>
                            </IconButton>
                        </Tooltip>
                    </Stack> 
                </CardContent>
            </Card>
            <Stack
                direction="row"
                alignItems="center"
                spacing={2}
            >
                <IconButton aria-label="linkedIn" href="https://www.linkedin.com/in/ignacio-rivano-gonzalez/" target="_blank">
                    <LinkedInIcon fontSize="large" color="linkedIn"/>
                </IconButton>
                {/* <IconButton aria-label="facebook" href="">
                    <FacebookIcon fontSize="large" color="facebook"/>
                </IconButton> */}
                <IconButton aria-label="whatsApp" href="https://api.whatsapp.com/send?phone=56984281885" target="_blank">
                    <WhatsAppIcon fontSize="large" color="whatsApp"/>
                </IconButton>
            </Stack>
        </Stack>
    </>)
}